import type { IHealthDbServiceProvider } from '#domain/healthDb';
import { defineStore } from 'pinia';
import { useInject } from '../core/utils/useInject';

export const useHealthDbStore = defineStore('healthDb', {
  state: () => ({
    message: '',
    createdAt: null as Date | null,
    error: null as string | null
  }),
  actions: {
    async fetchLastHealthDbRecord() {
      try {
        const userDbServiceProvider = useInject<IHealthDbServiceProvider>('healthDbServiceProvider');
        const record = await userDbServiceProvider.getLastHealthDbRecord();
        this.message = record.message;
        this.createdAt = record.createdAt ?? null;
      } catch (error) {
        if (error instanceof Error) {
          this.error = error.message;
        }
      }
    }
  }
});
